import Plausible from 'plausible-tracker'
import { TRACKING_ENABLED } from '../config';

const { trackPageview, trackEvent } = Plausible({
  trackLocalhost: TRACKING_ENABLED || false,
  domain: process.env.PLAUSIBLE_DOMAIN || 'gps.globe-groupe.com',
})

export { trackPageview, trackEvent }
